import * as types from "../types/superCorporateType";

const initialState = {
    supercorporates: [],
    totalElements: 0,
    number: 0,
    size: 0,
    vatAccounts: [],
    vatAccount: [],
    commissionAccounts: []
};

const superCorporateReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case types.GET_SUPER_CORPORATE:
            return {
                ...state,
                supercorporates: payload.content,
                totalElements: payload.totalElements,
                size: payload.size,
                number: payload.number
            };
        case types.GET_SUPER_COMMERCIAL_ACCOUNTS:
            return {
                ...state,
                commissionAccounts: payload
            };
        case types.GET_SUPER_VAT_ACCOUNTS:
            return {
                ...state,
                vatAccounts: payload
            };
        case types.GET_SUPER_VAT_ACCOUNT:
            return {
                ...state,
                vatAccount: payload
            };
        default:
            return state;
    }
};

export default superCorporateReducer;
